module.exports = [
	{
		"product": "beef",
		"objectID": "23",
		"category": "Young Prime",
		"animalCut": "shin",
		"meatCut": "Osso Buco",
		"price": "6.99",
		"cooking": "Slow Cook",
		"picture": "./images/beef/osso-bucco.png",
		"description": "Osso buco is a Milanese speciality of cross-cut veal shanks braised with vegetables, white wine and broth. It is often garnished with gremolata. The tissue breaks down when prepared using slow moist cooking methods such as casseroling and braising imparting a rich, full bodied flavour and a delicious gelatinous texture."
	},
	{
		"product": "beef",
		"objectID": "10",
		"category": "Young Prime",
		"animalCut": "shin",
		"meatCut": "Dolphin Shin",
		"price": "8.5",
		"cooking": "Slow Cook",
		"picture": "./images/wcms-placeholder.png",
		"description": "Generally regarded as one of the tougher cuts of meat, the dolphin shin is typically sold as a stewing meat or in mince form. The shin can also be provided in bone cuts, but is only suitable for a very slow cook to enable the meat to break down."
	},
	{
		"product": "beef",
		"objectID": "16",
		"category": "Young Prime",
		"animalCut": "shin",
		"meatCut": "Heel Shin",
		"price": "8.2",
		"cooking": "Slow Cook",
		"picture": "./images/wcms-placeholder.png",
		"description": "Classic slow cooking meat when combined with its ideal partner, cow heel, it will certainly stick to your ribs in the cold weather.  The shin breaks down to provide tasty meat and a thick gravy, beautifully tender."
	},
	{
		"product": "beef",
		"objectID": "14",
		"category": "Young Prime",
		"animalCut": "shin",
		"meatCut": "Boneless Shin",
		"price": "7.1",
		"cooking": "Slow Cook",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale,f_auto/v1502851184/wcms/Beef_shin_boneless_ofef8f",
		"description": "A cost-effective Beef portion, the Boneless Shin is taken from the front part of a cow’s lower leg. Much like other tough portions of Beef, slow-moist cooking methods are recommended to break the connective tissues and soften up this cut. Braising and stewing work well with the Boneless Shin cut. The Boneless Shin is extracted from the fore and hind parts of an animal’s legs."
	},
	{
		"product": "beef",
		"objectID": "11",
		"category": "Young Prime",
		"animalCut": "silverside",
		"meatCut": "Eyeround",
		"price": "8.5",
		"cooking": "Roast",
		"picture": "./images/beef/eyeround.png",
		"description": "Eye round is one of the muscles that make up silverside, a cut that sits on the outside thigh of the hind leg. It is a lean piece of beef that is best suited to cutting into a dice for slow, moist cooking methods such as a braise or casserole."
	},
	{
		"product": "beef",
		"objectID": "30",
		"category": "Young Prime",
		"meatCut": "SilverSide",
		"animalCut": "silverside",
		"price": "7.99",
		"cooking": "Roast",
		"picture": "./images/beef/silverside.png",
		"description": "The silverside comes from the outside of the rear leg and sits between the knuckle and the topside Being a muscle heavily used for walking, the silverside requires the gentle moist cooking of corning to produce a tender and delicious beef dish."
	},
	{
		"product": "beef",
		"objectID": "26",
		"category": "Young Prime",
		"meatCut": "SilverSide Roast",
		"animalCut": "silverside",
		"price": "9.5",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Taken from the hindquarter this is a large, lean, boneless cut of meat with very little marbling of fat and a wide-grained texture. It gets its name from the shiny silvery membrane covering its internal surface. The silverside requires gentle moist cooking of corning to produce a tender and delicious roast dish."
	},
	{
		"product": "beef",
		"objectID": "40",
		"category": "Young Prime",
		"meatCut": "TopSide",
		"animalCut": "silverside",
		"price": "7.49",
		"cooking": "Roast",
		"picture": "./images/beef/topside.png",
		"description": "Topside comes from the inside of the hind leg, between the thick flank and the silverside. Topside is extremely lean and performs best when diced for slow-cooking in a hearty casserole or braise."
	},
	{
		"product": "beef",
		"objectID": "41",
		"category": "Young Prime",
		"meatCut": "TopSide Clean",
		"animalCut": "silverside",
		"price": "11.2",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Topside comes from the inside of the hind leg, between the thick flank and the silverside. Topside is extremely lean and performs best when diced for slow-cooking in a hearty casserole or braise."
	},
	{
		"product": "beef",
		"objectID": "42",
		"category": "Young Prime",
		"meatCut": "TopSide Cap Off",
		"animalCut": "silverside",
		"price": "10.5",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Topside Cap Off is prepared from the Topside (item 2000) by the removal of the M. gracilis muscle along the natural seam. Fat deposits are removed. Topside cap off is extremely lean and performs best when diced for slow-cooking in a braise or minced (with added fat) for burgers.  Topside cap off responds well to tenderisation."
	},
	{
		"product": "beef",
		"objectID": "19",
		"category": "Young Prime",
		"meatCut": "Knuckle Round",
		"animalCut": "knuckle",
		"price": "8.5",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Beef knuckle is a versatile cut of meat originating from the round primal cut, which is located in the rear of the animal. An entire beef knuckle weighs 12 to 16 pound. It can be carved into several other cuts, including kabobs and minute steaks. Beef knuckle is also known as beef ball tip roast, sirloin tip roast and French roll roast. In addition to roasts, products from the beef knuckle portion are often used in Beef Stroganoff and stir fry."
	},
	{
		"product": "beef",
		"objectID": "28",
		"category": "Young Prime",
		"meatCut": "Rump",
		"animalCut": "knuckle",
		"price": "9.99",
		"cooking": "Roast",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale/v1502851184/wcms/Beef_rump_whole_azl2z6",
		"description": "Another well-known cut of beef, the rump is generally a slightly cheaper cut than its neighbour the sirloin due to not being quite as tender. Can be used for roasts or cutting into steaks. Many consider the rump to contain more flavour than the sirloin. It is a great full flavoured piece of beef."
	},
	{
		"product": "beef",
		"objectID": "29",
		"category": "Young Prime",
		"meatCut": "Rump Steak (Sliced)",
		"animalCut": "rump",
		"price": "10.99",
		"cooking": "Roast",
		"picture": "./images/beef/rump-steak.png",
		"description": "A beef round rump cut, whether it is boneless or bone-in, is a flavourful meat, but it needs some care to prevent toughness when cooking. This cut of meat is usually wet-roasted or braised to prevent the meat drying out. However, the rump can also be sliced into steaks and pan-fried."
	},
	{
		"product": "beef",
		"objectID": "3",
		"category": "Young Prime",
		"meatCut": "Butt Fillet",
		"animalCut": "tenderloin",
		"price": "16.5",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Boneless butt tenderloin is the thickest end of the tenderloin, which is a long fillet cut from a loin of beef. The meat is very tender, making it suitable as cuts of beef roast or steak. Since this cut is taken from muscle that generally doesn’t get much of a workout, it’s not necessary to cook the meat with moist heat, a method reserved for less tender cuts. Whole-muscle meat, like boneless butt tenderloin, can be safely cooked to lower internal temperatures than some other cuts."
	},
	{
		"product": "beef",
		"objectID": "6",
		"category": "Young Prime",
		"meatCut": "Tenderloin Whole",
		"animalCut": "tenderloin",
		"price": "19.5",
		"cooking": "Roast",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale,f_auto/v1502840844/wcms/Beef_tenderloin_whole_fmu56b.jpg",
		"description": "Beef tenderloin is the most expensive cut of meat on the steer. But, there are ways to minimize that cost. The best way is to buy the tenderloin whole and untrimmed, bring it home, and trim it yourself. With little or no fat or connective tissue the fillet is best suited to portioning into steaks for pan-frying and barbecuing or strips for stir-frying, but is equally delicious roasted whole in a very hot oven."
	},
	{
		"product": "beef",
		"objectID": "13",
		"category": "Young Prime",
		"animalCut": "flank",
		"meatCut": "Flank Steak",
		"price": "11",
		"cooking": "Roast",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale,f_auto/v1502851184/wcms/Beef_flank_whole_joltzu",
		"description": "The flank steak is a beef steak cut from the abdominal muscles or lower chest of the cow. The flank is located directly beneath the loin in the abdominal area. long and flat, it has a coarse grain running along its length which adds another dimension to its appeal and application. Flank steak also performs extremely well under slow-cooking conditions."
	},
	{
		"product": "beef",
		"objectID": "38",
		"category": "Young Prime",
		"animalCut": "flank",
		"meatCut": "Thick Skirt",
		"price": "7.5",
		"cooking": "Roast",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale,f_auto/v1502851184/wcms/Beef_inside_skirt_vatlfv",
		"description": "Thick Skirt also known as Hanger Steak or Onlae, is renowned for its incredible intense flavour rather than its tenderness. The steak is covered with a tough membrane which should be removed before cooking. After slow-cooking this beef cut can be shredded with a fork and added to burritos or salads."
	},
	{
		"product": "beef",
		"objectID": "36",
		"category": "Young Prime",
		"animalCut": "shortloin",
		"meatCut": "T-Bone",
		"price": "13.5",
		"cooking": "Roast",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale,f_auto/v1502851184/wcms/beef/D_Beef_T_Bone_steak_angle_2_uosyhz",
		"description": "The T-bone and porterhouse are steaks of beef cut from the short loin. Both steaks include a T-shaped bone with meat on each side. The t-shaped bone in the T-bone steak is from the back of the animal. The fillet and sirloin muscles sit on opposite sides of this t-shaped bone to form the T-bone steak. With little or no fat or connective tissue the T-bone is a quintessential Aussie steak perfect for pan-frying or barbecuing."
	},
	{
		"product": "beef",
		"objectID": "33",
		"category": "Young Prime",
		"animalCut": "shortloin",
		"meatCut": "Whole Sirloin",
		"price": "11.2",
		"cooking": "Roast",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale,f_auto/v1502840976/wcms/Beef_shortloin_whole_lxrpbn",
		"description": "The Sirloin comes from the hindquarter of the carcase and is separated from the rump by a straight cut between the last vertebrae along the back and the hip bone. The tenderloin and Striploin muscles sit on opposite sides of the t-shaped bone to form the basic cut to come from the Sirloin- the T-bone steak."
	},
	{
		"product": "beef",
		"objectID": "34",
		"category": "Young Prime",
		"animalCut": "shortloin",
		"meatCut": "Denuded Striploin",
		"price": "12.99",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Denuding a tenderloin is removing the side muscle and all the silverskin on the top. It’s mostly fat and sinew with some meat."
	},
	{
		"product": "beef",
		"objectID": "9",
		"category": "Young Prime",
		"animalCut": "cubeRoll",
		"meatCut": "Cube Roll",
		"price": "13.5",
		"cooking": "Roast",
		"picture": "./images/cube-roll.jpg",
		"description": "Cube roll is a cut of beef, usually top round or top sirloin, tenderized and flattened by pounding with a meat tenderizer or use of an electric tenderizer. The name refers to the shape of the indentations left by that process. Given its tender nature it can also be sliced into steaks to barbecue and pan-fry or strips to stir-fry."
	},
	{
		"product": "beef",
		"objectID": "12",
		"category": "Young Prime",
		"animalCut": "cubeRoll",
		"meatCut": "Beef Fingers",
		"price": "7.5",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Beef Fingers usually consist of 2–3 long by 1/2 wide strips of steak (usually top sirloin), battered with a tempura-like or flour batter, and deep-fried in oil. Typically, they are served with French fries and a buttered piece of thick toast."
	},
	{
		"product": "beef",
		"objectID": "27",
		"category": "Young Prime",
		"animalCut": "cubeRoll",
		"meatCut": "Rib Eye",
		"price": "14.99",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "The rib eye is a beef steak from the rib section. The rib section of beef spans from ribs six through twelve. Ribeye steaks are mostly composed of the longissimus dorsi muscle but also contain the complexus and spinalis muscles. This boneless steak is rich, tender, juicy and full-flavoured, with generous marbling throughout."
	},
	{
		"product": "beef",
		"objectID": "31",
		"category": "Young Prime",
		"animalCut": "cubeRoll",
		"meatCut": "Short Ribs",
		"price": "6.8",
		"cooking": "Roast",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale,f_auto/v1502851184/wcms/Beef_short_ribs",
		"description": "Short ribs are a cut of beef taken from the brisket, chuck, plate, or rib areas of beef cattle. They consist of a short portion of the rib bone, which is overlain by meat which varies in thickness. Short ribs taste great when they are slow cooked in red wine and stock."
	},
	{
		"product": "beef",
		"objectID": "0",
		"category": "Young Prime",
		"animalCut": "blade",
		"meatCut": "Bolar Roast cut in half",
		"isInStock": "true",
		"price": "8.99",
		"saving": "2.00",
		"picture": "./images/BLDRST_RET.jpg",
		"description": "It's taken from the part of the carcass that they call the, Blade, but the Bolar part of their blade is more commonly referred to in the United States as, Bottom Sirloin', or after defatting and trimming, Triangle Tip. Is tastes great when it is cooked whole as a roast, sliced into steaks and cooked on the barbecue or in a pan.",
		"cooking": [
			{
				"barbecue": "./images/cooking/barbecue.png",
				"pan": "./images/cooking/pan.png"
			}
		]
	},
	{
		"product": "beef",
		"objectID": "24",
		"category": "Young Prime",
		"animalCut": "blade",
		"meatCut": "Oyster blade",
		"isInStock": "true",
		"price": "7.99",
		"saving": "2.00",
		"cooking": "Roast",
		"picture": "./images/oysterblade-whole.jpg",
		"description": "Flat iron steak, butlers' steak, or oyster blade steak is a cut of steak cut with the grain from the shoulder of the animal. This produces a flavourful cut that is a bit tough because it contains a gristly fascia membrane unless removed."
	},
	{
		"product": "beef",
		"objectID": "45",
		"category": "Young Beef",
		"animalCut": "chuck",
		"meatCut": "Chuck",
		"isInStock": "true",
		"price": "8.99",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Being one of the neck muscles used to support the head, chuck contains a great deal of connective tissue and therefore suits moist slow-cooking techniques that break down the connective tissue. It is best for curries and stews with great full flavour and a fantastic gelatinous texture."
	},
	{
		"product": "beef",
		"objectID": "5",
		"category": "Young Prime",
		"animalCut": "chuck",
		"meatCut": "Chuck Whole",
		"price": "7.99",
		"cooking": "Roast",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale,f_auto/v1502838210/wcms/Beef_chuck_whole",
		"description": "Beef chuck is a huge primal cut that comes mainly from the shoulder section of the steer, as well as parts of the neck, ribs, and the upper arm. The entire thing can weigh more than 100 pounds, and it makes up fully 30 percent of an entire side of beef. These tough muscles are themselves held together at all sorts of funny angles by numerous bits of sinew and connective tissue, which are also tough and chewy, especially when cooked improperly."
	},
	{
		"product": "beef",
		"objectID": "8",
		"category": "Young Prime",
		"animalCut": "chuck",
		"meatCut": "Chuck Tender",
		"price": "8.99",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "This cut is usually grilled or broiled; a thicker version is sold as a 7-bone roast or chuck roast and is usually cooked with liquid as a pot roast. The bone-in chuck steak or roast is one of the more economical cuts of beef. Perfect for slow cooked meals, curries and stews with a great rich flavour."
	},
	{
		"product": "beef",
		"objectID": "32",
		"category": "Young Prime",
		"animalCut": "chuck",
		"meatCut": "Chuck Rib Plate",
		"price": "6",
		"cooking": "Roast",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale,f_auto/v1502838206/wcms/Beef_chuck_ribs",
		"description": "Short ribs are cut from the Chuck and the Plate (top of the rib bones) and beef back ribs are what is remaining after the rib roast is boned out. Short Ribs are cut parallel to the bone and may also be sold boneless. This meat is rich in flavour."
	},
	{
		"product": "beef",
		"objectID": "25",
		"category": "Young Prime",
		"animalCut": "brisket",
		"meatCut": "Point End Brisket Deckle removed",
		"price": "7.99",
		"cooking": "Roast",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale,f_auto/v1502851184/wcms/Beef_point_end_brisket_jq6ack",
		"description": "The point is a lump of meat that partially overlaps one end of the flat. Avoid small, super-trimmed brisket flats with the point removed. The point end brisket is essentially the pectoral muscles from the chest/ brisket area between the front legs. Being a well exercised muscle, the point end has a high degree of connective tissue and is best suited to slow wet cooking methods such as braising and casseroling. This beef cut is perfect for shredding as it literally pulls apart when cooked."
	},
	{
		"product": "beef",
		"objectID": "22",
		"category": "Young Prime",
		"animalCut": "other",
		"meatCut": "Marrow Bone (cut)",
		"price": "5.00 ea",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "It's deliciously rich and creamy, like meat-flavoured butter. You can use marrow bones to make bone broth, or you can roast the bones and use the marrow the same way you would use butter -- spread it on toast, cook eggs or roast vegetables with it, or let it melt over your steak while it's resting."
	},
	{
		"product": "beef",
		"objectID": "4",
		"category": "Young Prime",
		"animalCut": "other",
		"meatCut": "Beef Cheeck",
		"price": "9.99",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "A less common cut of meat, the cheek is again best served slow cooked and moist to release the flavours and keep a moist consistency. Generally, a cheap cut of meat, if cooked with patience can serve smiles all round!"
	},
	{
		"product": "beef",
		"objectID": "15",
		"category": "Young Prime",
		"animalCut": "other",
		"meatCut": "Beef Hearts",
		"price": "1.50 each",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "When it comes to calories and protein, beef heart is about equal to white-meat chicken. Beef heart meat is the muscle that's been trimmed from the heart wall. “Beef heart” includes the meat and essentially everything else—the blood vessels, fat, and blood chambers."
	},
	{
		"product": "beef",
		"objectID": "18",
		"category": "Young Prime",
		"animalCut": "other",
		"meatCut": "Beef Kidney",
		"price": "1.5 each",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "The kidneys of beef cattle, known as ox kidney inevitably tend towards toughness but when cooked slowly until tender. Beef kidneys are simple to prepare for cooking, typically they are cut into bite size pieces to make the most beautiful stew or a classic Steak and Kidney Pie. Cooking tip: Season and fry the beef kidney with onions & garlic - all this flavours are enhanced by each other."
	},
	{
		"product": "beef",
		"objectID": "35",
		"category": "Young Prime",
		"animalCut": "other",
		"meatCut": "Ox Tail",
		"price": "8.2",
		"cooking": "Roast",
		"picture": "https://res.cloudinary.com/react-web/image/upload/w_150,c_scale,f_auto/v1502851184/wcms/Beef_ox_tail_sliced_dughao",
		"description": "Oxtail is the culinary name for the tail of cattle. Formerly, it referred only to the tail of an ox or steer, a bullock (a castrated male). Oxtail is a bony, gelatine-rich meat, which is usually slow-cooked as a stew or braised. It is a traditional stock base for a soup."
	},
	{
		"product": "beef",
		"objectID": "37",
		"category": "Young Prime",
		"animalCut": "other",
		"meatCut": "Tendons (Beef)",
		"price": "7",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Beef tendons only take four hours of cooking time to soften as opposed to ten. The peripheral parts of the tendon carry bits of flesh and fat as well. Beef tendon also possesses its own unique taste. Beef tendon is truly beefy on its own; enhanced with additional seasonings, the tendon has a meaty depth that belies the lack of muscle content."
	},
	{
		"product": "beef",
		"objectID": "39",
		"category": "Young Prime",
		"animalCut": "other",
		"meatCut": "Tongues (Beef)",
		"price": "10.00 each",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Beef tongue or neat's tongue is a dish made of the tongue of a cow. Beef tongue is very high in fat, and 72% of its calories come from fat. It is very cheap and relatively easy to prepare. It’s sometimes even tastier than beef!"
	},
	{
		"objectID": "71",
		"category": "Misc",
		"animalCut": "other",
		"meatCut": "Corned SilverSide",
		"price": "7.99",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Corned SilverSide beef is a salt-cured beef product. The term comes from the treatment of the meat with large grained rock salt, also called 'corns' of salt. Most recipes include nitrates or nitrites, which gives the beef a pinkish colour."
	},
	{
		"product": "misc",
		"objectID": "72",
		"category": "Misc",
		"animalCut": "other",
		"meatCut": "Pet Mince",
		"price": "2.5",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Usually trimmed from beef parts such as the heart or cheek, this is perfect for your pet. Dogs enjoy this food and it is also healthy for pets as it is filled with less fattier substances and also cheap at the same time."
	},
	{
		"product": "misc",
		"objectID": "73",
		"category": "Misc",
		"animalCut": "other",
		"meatCut": "Sausage Beef",
		"price": "5",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "Our beef sausages are slow-cooked with natural spices using quality cuts of meat."
	},
	{
		"product": "misc",
		"objectID": "77",
		"category": "Misc",
		"animalCut": "other",
		"meatCut": "Stir Fry",
		"price": "11.49",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "The food is cooked quickly by cutting into small pieces and stirring constantly in a lightly oiled wok or frying pan over high heat."
	},
	{
		"product": "beef",
		"objectID": "78",
		"category": "Misc",
		"animalCut": "other",
		"meatCut": "Diced Beef",
		"price": "9.99",
		"cooking": "Roast",
		"picture": "./images/wcms-placeholder.png",
		"description": "You can create versatile, budget-friendly dinners with diced beef. Flavourful cut that offers convenience at an attractive price point; diced beef is extremely versatile and the basis for a multitude of home-style entrees such as stews. It is also good for making beef curry."
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Beef/beef/beef.json
// module id = 1442
// module chunks = 0